import React, { useState, useEffect } from "react";
import { get, map, isEmpty, filter } from "lodash";
import URLCheckerLink from "../components/Link/URLCheckerLinks";
import styled from "styled-components";
import { RichText } from "prismic-reactjs";
import { useSelector, useDispatch } from "react-redux";

const StlContainer = styled.div`
  border-radius: 42px;
  height: 100%;
  padding: 10px;
  img {
    max-width: 100%;
  }
  .info-wrapper {
    height: 100%;
  }
`;

const StlCOAButton = styled.button`
  border: none;
  display: block;
  margin: auto;
  border-radius: 44px;
  font-size: 20px;
  width: 90%;
  padding: 7px 0;
  margin-bottom: 10px;
  text-align: center;
  .coa-btn {
    transition: 100ms linear;
    &:hover {
      opacity: 0.5;
    }
  }
  .open {
    padding: 15px;
    a {
      display: block;
      font-size: 15px;
      word-wrap: break-word;
      margin-bottom: 15px;
    }
  }
`;

const COA = ({ id }) => {
  const dispatch = useDispatch();
  const prismicData = useSelector((state) =>
    get(state, `prismic.coa_slice_${id}.data[0]`)
  );
  const background = prismicData?.background_color;
  const textColor = prismicData?.text_color;
  const image = get(prismicData, "image.url");
  const productName = get(prismicData, "product_name[0].text");
  const links = prismicData?.links;
  const [openCOA, setOPenCOA] = useState(false);
  const clickCOA = () => {
    setOPenCOA(!openCOA);
  };

  useEffect(() => {
    dispatch({
      type: "PRISMIC_LOAD_LIST_BY_IDS",
      key: `coa_slice_${id}`,
      ids: [id],
    });
  }, [dispatch, id]);

  const hasLinks = filter(links, (el) => {
    return el.link.link_type !== "Any";
  });

  const renderLinks = map(links, (el, i) => {
    const url = get(el, "link.url");
    const expDate = get(el, "expiration_date");
    const linkText = get(el, "link_text");
    const today = new Date().toISOString().split("T")[0];

    if (!url || (expDate && today >= expDate)) return null;
    return (
      <URLCheckerLink
        key={i}
        href={url}
        url={url}
        target="_blank"
        rel="noopener noreferrer"
      >
        {!isEmpty(linkText) ? <RichText render={linkText} /> : url}
      </URLCheckerLink>
    );
  });

  return (
    <StlContainer style={{ background: background }}>
      <div className="info-wrapper flex-col">
        <p
          className="name dinamit-bold uppercase center-align"
          style={{ color: textColor }}
        >
          {productName}
        </p>
        <img src={image} />
        {!isEmpty(hasLinks) && (
          <StlCOAButton
            onClick={clickCOA}
            style={{ background: textColor, color: background }}
          >
            <p className="dinamit-bold cursor-pointer coa-btn">VIEW COA</p>
            <div className={openCOA ? "display-block open" : "display-none"}>
              {renderLinks}
            </div>
          </StlCOAButton>
        )}
      </div>
    </StlContainer>
  );
};

export default COA;
